import React, {Component} from "react";

class Content extends Component {
    render() {
        return (<div/>);
    }
}

export default Content;
